import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/cc883008a4d7bcfeafa6a2e5816cdde1/145343b2bde13a888d3f705e3f2c3ea4.png';

export default function DemoViewer() {
  const [searchParams] = useSearchParams();
  const url = searchParams.get('url');
  const projectName = searchParams.get('name') || 'Project';
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  // Safety timeout: if iframe doesn't trigger onLoad within 8 seconds, dismiss spinner
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  if (!url) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <p className="text-xl mb-4 font-bold text-gray-700">No Demo URL provided</p>
        <button onClick={() => navigate(-1)} className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Go Back</button>
      </div>
    );
  }

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-white">
      {/* Top Bar for closing the demo */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-[#0e1f38] flex items-center justify-between px-6 z-50 shadow-md">
        <div className="flex items-center gap-3 text-white">
          <img src={LOGO_URL} alt="Logo" className="w-10 h-10 rounded-lg object-contain" />
          <span className="font-bold text-lg hidden sm:block">BientoMart Demo Viewer</span>
        </div>
        <div className="flex items-center gap-4">
          <a href="/#contact" className="text-sm text-gray-300 hover:text-white transition flex items-center gap-1.5">
            <i className="ri-message-3-line"></i> Talk to us
          </a>
          <button 
            onClick={() => navigate(-1)}
            className="text-white bg-[#1a3050] hover:bg-[#234470] px-4 py-2 rounded-lg text-sm transition font-medium flex items-center gap-2 border border-gray-600"
          >
            <i className="ri-close-line"></i> Close Demo
          </button>
        </div>
      </div>

      {/* The External Project Iframe */}
      <div className="w-full h-full pt-16 relative">
        {isLoading && (
          <div className="absolute inset-0 pt-16 flex flex-col items-center justify-center bg-white z-40">
            <img src={LOGO_URL} alt="Loading Logo" className="w-32 h-32 object-contain animate-bounce mb-8" />
            <div className="flex flex-col items-center gap-4 text-center px-4">
              <div className="w-10 h-10 border-4 border-gray-200 border-t-[#0e1f38] rounded-full animate-spin"></div>
              <div className="space-y-2">
                <p className="text-gray-700 font-semibold tracking-wide text-lg">Loading Demo of {projectName}...</p>
                <p className="text-gray-500 text-sm max-w-md mx-auto">Kindly reach us or contact us to get such kind of project and many more.</p>
              </div>
            </div>
          </div>
        )}
        <iframe 
          src={url} 
          className="w-full h-full border-none bg-gray-50"
          title="Project Demo"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
}
